import React from 'react'
import styled from 'styled-components'

import Modal from '../../containers/Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

const AlertModal = ({ onClose, isOpen, onReturn, isLogout }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title={<ModalTitle>Istnieją niezapisane zmiany.</ModalTitle>}
  >
    <P>Czy na pewno chcesz wyjść bez zapisu?</P>
    <Footer justify="space-between">
      <Button label="Wróć" onClick={onClose} />
      {isLogout ? (
        <Button color="white" label="Wyloguj" marginLeft onClick={onReturn} />
      ) : (
        <Button color="white" label="Wyjdź" marginLeft onClick={onReturn} />
      )}
    </Footer>
  </Modal>
)

const ModalTitle = styled.span`
  font-weight: 400;
  margin-bottom: 40px;
  display: block;
`
const P = styled.p`
  padding-bottom: 10px;
`

const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default AlertModal
